import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '../services/translate.service';

@Pipe({
  name: 'translate',
  standalone: true,
  pure: false,
})
export class TranslatePipe implements PipeTransform, OnDestroy {
  private readonly sub: Subscription;

  constructor(
    private readonly translateService: TranslateService,
    private readonly cdr: ChangeDetectorRef,
  ) {
    // Forza la rivalutazione del template quando la lingua cambia in ritardo
    // (es. profilo utente caricato dopo il primo render della pagina).
    this.sub = this.translateService.currentLang$.subscribe(() => {
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  transform(value: string): string {
    if (!value) return '';
    return this.translateService.translate(value);
  }
}
